/* ============================================================
   TWO KXNGS WISHLIST PAGE (Oct 2026)
   Own list: draws the shopper's saved products from window.TKWish (assets/tk-wishlist.js).
   Each card is the theme's own Liquid (sections/tk-wishlist-card.liquid) rendered for that
   product through the Section Rendering API, so price, stock and sizes are always live.
   Pick or change a size right on the card, then add to cart.
   Signed in on a new device, "Loading" shows until the account's list arrives (TKWish.ready),
   and the line under the intro says whether the list is on the account or this device.

   Shared list: /pages/wishlist?items=handle:variantId,handle,...
   Someone else's list, read only: viewing it and tapping sizes never saves anything, on the
   device or the account. Add to cart per card, and "Add all to my wishlist", which only ever
   ADDS to the visitor's own list (never replaces it, never changes a size they already saved),
   and that list syncs like any other save.
   ============================================================ */
(function () {
'use strict';
var root = document.querySelector('[data-tk-wl-page]');
if (!root || root.__tkWlPage) return;
root.__tkWlPage = true;

var grid = root.querySelector('[data-tk-wl-grid]');
var empty = root.querySelector('[data-tk-wl-empty]');
var emptyTitle = root.querySelector('[data-tk-wl-empty-title]');
var loading = root.querySelector('[data-tk-wl-loading]');
var shareBar = root.querySelector('[data-tk-wl-share]');
var sharedBar = root.querySelector('[data-tk-wl-shared]');
var SECTION = root.getAttribute('data-card-section') || 'tk-wishlist-card';
var LIMIT = 6;      /* fetches at once */
var MAX_SHARED = 40;
var cache = {};     /* handle -> Promise<Element|null> */
var shared = parseShared();

function W() { return window.TKWish; }
function t(key, fallback) { var w = W(); return w && w.text ? w.text(key, fallback) : fallback; }
function say(name, fallback) { return root.getAttribute(name) || fallback; }
function toast(text, link) { var w = W(); if (w && w.toast) w.toast(text, link); }
function routeRoot() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }

/* ---------- a shared list in the address ---------- */
function parseShared() {
  var raw = null;
  try { raw = new URLSearchParams(window.location.search).get('items'); } catch (e) {}
  if (!raw) return null;
  var seen = {}, out = [];
  raw.split(',').forEach(function (part) {
    var bits = part.split(':');
    var h = (bits[0] || '').trim().toLowerCase();
    var v = (bits[1] || '').trim();
    if (!h || seen[h] || !/^[^\s\/?#:,%\\<>"']{1,255}$/.test(h)) return;
    seen[h] = true;
    if (out.length < MAX_SHARED) out.push({ h: h, v: /^\d{1,20}$/.test(v) ? v : null });
  });
  return out.length ? out : null;
}

/* ---------- cards ---------- */
var GONE = {}; /* the product was deleted or unpublished (404), unlike a network hiccup (null) */

function cardFor(handle) {
  if (!cache[handle]) {
    cache[handle] = fetch(routeRoot() + 'products/' + encodeURIComponent(handle) + '?section_id=' + SECTION, { credentials: 'same-origin' })
      .then(function (r) { return r.status === 404 ? GONE : (r.ok ? r.text() : ''); })
      .then(function (html) {
        if (html === GONE) return GONE;
        if (!html) return null;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.querySelector('[data-tk-wl-card]');
      })
      .catch(function () { delete cache[handle]; return null; });
  }
  return cache[handle].then(function (el) { return el === GONE ? GONE : (el ? el.cloneNode(true) : null); });
}

/* Run fetches a few at a time, keep the list order. */
function inBatches(items, fn) {
  var out = new Array(items.length), i = 0;
  function next() {
    if (i >= items.length) return Promise.resolve();
    var k = i++;
    return fn(items[k]).then(function (r) { out[k] = r; return next(); });
  }
  var lanes = [];
  for (var n = 0; n < Math.min(LIMIT, items.length); n++) lanes.push(next());
  return Promise.all(lanes).then(function () { return out; });
}

function unlockIfDropped(card) {
  var at = parseInt(card.getAttribute('data-drops-at') || '', 10);
  if (card.hasAttribute('data-locked') && at && Date.now() / 1000 >= at) card.removeAttribute('data-locked');
}

function selectSize(card, variantId) {
  var chosen = null;
  card.querySelectorAll('[data-tk-wl-size]').forEach(function (b) {
    var on = !!variantId && b.getAttribute('data-tk-wl-size') === String(variantId);
    b.setAttribute('aria-pressed', String(on));
    if (on) chosen = b;
  });
  var atc = card.querySelector('[data-tk-wl-atc]');
  if (!atc) return;
  unlockIfDropped(card);
  /* Not dropped yet: the card's own "Coming soon" stands */
  if (card.hasAttribute('data-locked')) { atc.disabled = true; return; }
  var single = card.hasAttribute('data-single-variant');
  var available = single ? card.getAttribute('data-single-available') !== 'false' : !!chosen && !chosen.disabled;
  /* Every size sold out: say so, instead of asking for a size that can't be picked */
  var sizes = card.querySelectorAll('[data-tk-wl-size]');
  var allSold = !single && sizes.length > 0 && Array.prototype.every.call(sizes, function (b) { return b.disabled; });
  atc.disabled = !available;
  atc.textContent = single
    ? (available ? t('add', 'Add to cart') : t('sold', 'Sold out'))
    : (!chosen ? (allSold ? t('sold', 'Sold out') : t('pick', 'Pick a size')) : (chosen.disabled ? t('sold', 'Sold out') : t('add', 'Add to cart')));
  var low = card.querySelector('[data-tk-wl-low]');
  if (low) {
    var left = chosen ? parseInt(chosen.getAttribute('data-left') || '', 10) : NaN;
    low.textContent = left > 0 && left <= 3 ? t('left', 'Only [n] left').replace('[n]', String(left)) : '';
  }
}

function pickedVariant(card) {
  var single = card.getAttribute('data-single-variant');
  if (single) return single;
  var picked = card.querySelector('[data-tk-wl-size][aria-pressed="true"]');
  return picked ? picked.getAttribute('data-tk-wl-size') : null;
}

function show(cards) {
  var frag = document.createDocumentFragment();
  cards.forEach(function (c) { if (c) frag.appendChild(c); });
  grid.innerHTML = '';
  grid.appendChild(frag);
  if (loading) loading.hidden = true;
  var any = grid.children.length > 0;
  if (empty) empty.hidden = any;
  return any;
}

function startLoading() {
  if (loading && !grid.children.length) loading.hidden = false;
}

/* ---------- own list ---------- */
var renderSeq = 0; /* only the latest draw lands, if the list changes while cards are still loading */

function ownItems() { return W() ? W().items().filter(function (it) { return it.h; }) : []; }

/* Saves the page can never show (no handle, or the product is gone) come off the list, so the header count
   matches the cards and nothing is left that can't be removed. Signed in, they come off the account too
   (a guest's tidy-up isn't counted as a removal). */
function dropSaves(ids) {
  if (!ids.length || !W()) return;
  quiet = true;
  ids.forEach(function (p) { W().remove(p, { cleanup: true }); });
  quiet = false;
  last = key();
}

function renderOwn() {
  if (W()) dropSaves(W().items().filter(function (it) { return !it.h; }).map(function (it) { return it.p; }));
  var items = ownItems();
  if (!items.length) {
    renderSeq++;
    grid.innerHTML = '';
    if (loading) loading.hidden = true;
    if (empty) empty.hidden = false;
    if (shareBar) shareBar.hidden = true;
    return Promise.resolve();
  }
  if (empty) empty.hidden = true;
  startLoading();
  var seq = ++renderSeq;
  var gone = [];
  return inBatches(items, function (it) {
    return cardFor(it.h).then(function (card) {
      if (card === GONE) { gone.push(it.p); return null; }
      if (!card) return null;
      selectSize(card, it.v);
      return card;
    });
  }).then(function (cards) {
    if (seq !== renderSeq) return;
    dropSaves(gone);
    var any = show(cards);
    if (shareBar) shareBar.hidden = !any;
  });
}

/* ---------- shared list ---------- */
function renderShared() {
  var title = root.querySelector('[data-tk-wl-title]');
  var note = root.querySelector('[data-tk-wl-note]');
  if (title) title.textContent = say('data-shared-heading', 'A list worth looking at');
  if (note) { note.textContent = say('data-shared-text', 'Picked out and sent your way. Choose a size and add to cart.'); note.hidden = false; }
  if (emptyTitle) emptyTitle.textContent = say('data-shared-empty', "These pieces aren't available right now.");
  if (shareBar) shareBar.hidden = true;
  root.setAttribute('data-shared-view', '');
  startLoading();
  return inBatches(shared, function (it) {
    return cardFor(it.h).then(function (card) {
      if (!card || card === GONE) return null;
      var del = card.querySelector('[data-tk-wl-remove]');
      if (del) del.remove();
      selectSize(card, it.v);
      return card;
    });
  }).then(function (cards) {
    var any = show(cards);
    if (sharedBar) sharedBar.hidden = !any;
  });
}

function addAll(btn) {
  var w = W();
  if (!w || btn.disabled) return;
  grid.querySelectorAll('[data-tk-wl-card]').forEach(function (card) {
    var p = card.getAttribute('data-product-id');
    if (!p) return;
    var v = pickedVariant(card);
    var mine = w.get(p);
    if (mine) {
      /* already on their list: keep their size, only fill one in if they had none */
      if (!mine.v && v) w.setSize(p, v);
      return;
    }
    w.add({ p: p, h: card.getAttribute('data-handle'), v: v }, 'shared', { title: card.getAttribute('data-title'), price: card.getAttribute('data-price') });
  });
  var done = say('data-added-all', 'Added to your wishlist');
  btn.disabled = true;
  btn.textContent = done;
  toast(done, true);
}

/* ---------- share the own list ---------- */
function shareUrl() {
  var parts = ownItems().slice(0, MAX_SHARED).map(function (it) {
    return encodeURIComponent(it.h) + (it.v ? ':' + it.v : '');
  });
  return window.location.origin + window.location.pathname + '?items=' + parts.join(',');
}

function legacyCopy(text) {
  try {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.cssText = 'position:fixed;top:0;left:0;opacity:0;';
    document.body.appendChild(ta);
    ta.select();
    var ok = document.execCommand('copy');
    ta.remove();
    return ok;
  } catch (e) { return false; }
}

/* Last resort: show the link so it can be copied by hand */
function showLink(url) {
  var wrap = root.querySelector('[data-tk-wl-share-out-wrap]');
  var out = root.querySelector('[data-tk-wl-share-out]');
  if (!wrap || !out) return;
  wrap.hidden = false;
  out.value = url;
  out.focus();
  out.select();
}

function copyLink(url) {
  var done = function () { toast(say('data-copied', 'Link copied'), false); };
  var fallback = function () { if (legacyCopy(url)) done(); else showLink(url); };
  if (navigator.clipboard && window.isSecureContext) {
    navigator.clipboard.writeText(url).then(done, fallback);
  } else {
    fallback();
  }
}

function onShare() {
  if (!ownItems().length) return;
  var url = shareUrl();
  var phone = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
  if (phone && navigator.share) {
    navigator.share({ title: document.title, text: say('data-share-message', ''), url: url }).catch(function (err) {
      if (err && err.name === 'AbortError') return; /* they closed the share sheet */
      copyLink(url);
    });
    return;
  }
  copyLink(url);
}

/* ---------- add to cart ----------
   The way the theme's own product form does it (theme.js ProductForm): the drawer, count,
   dot and free-shipping bar all re-render from one cart:change, and the drawer opens. */
function addToCart(card, btn) {
  unlockIfDropped(card);
  if (card.hasAttribute('data-locked')) return;
  var id = pickedVariant(card);
  if (!id) return;
  btn.disabled = true;
  var label = btn.textContent;
  var sections = [];
  try { document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } })); } catch (e) {}
  var added;
  fetch(routeRoot() + 'cart/add.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }], sections: sections.join(','), sections_url: routeRoot() + 'variants/' + id })
  }).then(function (r) {
    /* a 429 or 5xx can come back as an HTML page: never show its raw text */
    return r.text().then(function (body) {
      var j = null;
      try { j = JSON.parse(body); } catch (e) {}
      if (!r.ok || !j) throw new Error(j && (j.description || j.message) || t('cartError', 'Could not add that right now. Try again in a moment.'));
      added = j;
      return fetch(routeRoot() + 'cart.js', { credentials: 'same-origin' }).then(function (c) { return c.json(); });
    });
  }).then(function (cart) {
    btn.textContent = t('added', 'Added');
    var settings = (window.themeVariables && window.themeVariables.settings) || {};
    if (settings.cartType === 'page') { window.location.href = routeRoot() + 'cart'; return; }
    cart.sections = added && added.sections;
    document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cart } }));
    setTimeout(function () { btn.disabled = false; btn.textContent = label; }, 2200);
  }).catch(function (err) {
    btn.disabled = false;
    btn.textContent = label;
    toast(err && err.message ? String(err.message) : t('sold', 'Sold out'), false);
  });
}

/* ---------- taps ---------- */
var quiet = false; /* our own changes: the cards on screen are already right */

root.addEventListener('click', function (e) {
  var el = e.target;
  if (!el || !el.closest) return;
  if (el.closest('[data-tk-wl-share-btn]')) { e.preventDefault(); onShare(); return; }
  var all = el.closest('[data-tk-wl-addall]');
  if (all) { e.preventDefault(); addAll(all); return; }
  var card = el.closest('[data-tk-wl-card]');
  if (!card) return;
  var p = card.getAttribute('data-product-id');
  var size = el.closest('[data-tk-wl-size]');
  if (size) {
    e.preventDefault();
    if (size.disabled) return;
    selectSize(card, size.getAttribute('data-tk-wl-size'));
    /* own list: remember the new size. A shared list stays as it was sent. */
    if (!shared && W()) { quiet = true; W().setSize(p, size.getAttribute('data-tk-wl-size')); quiet = false; }
    return;
  }
  var atc = el.closest('[data-tk-wl-atc]');
  if (atc) { e.preventDefault(); addToCart(card, atc); return; }
  var del = el.closest('[data-tk-wl-remove]');
  if (del && !shared) {
    e.preventDefault();
    card.remove();
    if (W()) { quiet = true; W().remove(p); quiet = false; }
    var any = grid.children.length > 0;
    if (empty) empty.hidden = any;
    if (shareBar) shareBar.hidden = !any;
  }
});

/* Signed in: say "Saved to your account" only once the account really has the list
   (until then, or with the proxy away, "Saved on this device"). Guests: Liquid already shows their line. */
function showWhere() {
  var w = W();
  if (!w || !w.signedIn || shared) return;
  var acct = root.querySelector('[data-tk-wl-where="account"]');
  var dev = root.querySelector('[data-tk-wl-where="device"]');
  var on = !!(w.onAccount && w.onAccount());
  if (acct) acct.hidden = !on;
  if (dev) dev.hidden = on;
}

/* Redraw the own list when it changes elsewhere (another tab, account sync, the Back button) */
var last = '';
function key() { return ownItems().map(function (it) { return it.p; }).join(','); }
document.addEventListener('tk:wishlist', function () {
  if (shared) return;
  showWhere();
  var k = key();
  if (quiet || k === last) { last = k; return; }
  last = k;
  renderOwn();
});

/* The page swapped to the shared heading early, but the link held nothing usable: put the own list's words back */
function restoreOwnWords() {
  if (!root.hasAttribute('data-shared-early')) return;
  root.removeAttribute('data-shared-early');
  root.querySelectorAll('[data-tk-wl-title][data-own], [data-tk-wl-note][data-own]').forEach(function (el) {
    el.textContent = el.getAttribute('data-own');
    if (el.hasAttribute('data-tk-wl-note')) el.hidden = !el.textContent;
  });
}

function boot() {
  if (shared) { renderShared(); return; }
  restoreOwnWords();
  last = key();
  var w = W();
  /* Signed in on a new device: the list is still on its way from the account */
  if (w && w.synced === false && !ownItems().length && w.ready) {
    startLoading();
    w.ready.then(function () { showWhere(); last = key(); renderOwn(); });
    return;
  }
  showWhere();
  renderOwn();
}
if (window.TKWish) boot(); else document.addEventListener('DOMContentLoaded', boot);
})();
